import { TotalUsersType, TourBalanceType } from "../../Type/Widgets/GeneralWidgetsType";
import {
  averageProfitChartData,
  averageSaleChartData,
  bitcoinChartData,
  ethereumChartData,
  ordersChartData,
  profitChartData,
  radialCommonOption2ChartData,
  radialCommonOption3ChartData,
  radialCommonOption4ChartData,
  radialCommonOptionChartData,
  travelChartData,
} from "./WidgetsChartData";

export const bitcoinData = [
  {
    svg: "beta",
    title: "Bitcoin",
    titleSub: "BTC",
    chart: bitcoinChartData,
    amount: "$21,43",
    percentage: "+50%",
    class: "warning",
  },
  {
    svg: "eth",
    title: "Ethereum",
    titleSub: "ETC",
    chart: ethereumChartData,
    amount: "$7,450",
    percentage: "+35%",
    class: "primary",
  },
  {
    svg: "ltc",
    title: "Leave Travel",
    titleSub: "LTC",
    chart: travelChartData,
    amount: "$2,198",
    percentage: "+73%",
    class: "success",
  },
];

export const averagePerDayData = [
  {
    header: "Average Sales Per Day",
    count: "45,908",
    color: "primary",
    per: "+5.7%",
    description: "The point of using Lorem Ipsum",
    chart: averageSaleChartData,
  },
  {
    header: "Average Profit Per Day",
    count: "89.6%",
    color: "secondary",
    per: "+2.7%",
    description: "The point of using Lorem Ipsum",
    chart: averageProfitChartData,
  },
];

export const purchaseData = [
  {
    color: "secondary",
    svg: "cart",
    svg2: "halfcircle",
    count: "10,000",
    title: "Purchase",
    result: "+50%",
    icon: "icon-arrow-up",
  },
  {
    color: "primary",
    svg: "tag",
    svg2: "halfcircle",
    count: "4,200",
    title: "Sales",
    result: "+70%",
    icon: "icon-arrow-up",
  },
  {
    color: "warning",
    svg: "return-box",
    svg2: "halfcircle",
    count: "7000",
    title: "Sales return",
    result: "-20%",
    icon: "icon-arrow-down",
  },
  {
    color: "success",
    svg: "rate",
    svg2: "halfcircle",
    count: "5700",
    title: "Purchase rate",
    result: "+70%",
    icon: "icon-arrow-up",
  },
];

export const completeCourseData = [
  {
    count: "100+",
    header: "Completed Courses",
    btn: "View course",
    svg1: "course-1",
    svg2: "arrowright",
  },
  {
    count: "50+",
    header: "In Progress Courses",
    btn: "View course",
    svg1: "course-2",
    svg2: "arrowright",
    class: "warning",
  },
];

export const totalUsersData: TotalUsersType[] = [
  {
    color: "primary",
    count: "178,098",
    result: "+30.89",
    fontcolor: "primary",
    icon: "icon-arrow-up",
    fIcon: "UserPlus",
  },
  {
    color: "success",
    count: "178,098",
    result: "-08.89",
    fontcolor: "danger",
    icon: "icon-arrow-down",
    fIcon: "UserMinus",
  },
];

export const socialWidgetsData = [
  {
    img: "1.png",
    alt: "facebook icon",
    title: "Facebook",
    count: "+22.9%",
    followers: "12,098",
    content: "Followers",
    chart: radialCommonOptionChartData,
  },
  {
    img: "3.png",
    alt: "twitter icon",
    title: "Twitter",
    count: "+14.09%",
    followers: "12,564",
    content: "Followers",
    chart: radialCommonOption3ChartData,
  },
  {
    img: "2.png",
    alt: "instagram icon",
    title: "Instagram",
    count: "+27.4%",
    followers: "15,080",
    content: "Followers",
    chart: radialCommonOption2ChartData,
  },

  {
    img: "4.png",
    alt: "you tube icon",
    title: "Youtube",
    count: "+22.9%",
    followers: "68,954",
    content: "Followers",
    chart: radialCommonOption4ChartData,
  },
];

export const newOrdersData = [
  {
    title: "New Orders",
    number: "2,435",
    color: "primary",
    percentage: "+50%",
    icon: "icon-arrow-up",
    svg: "new-order",
  },
  {
    title: "New Customers",
    number: "2,908",
    color: "warning",
    percentage: "+20%",
    icon: "icon-arrow-up",
    svg: "customers",
  },
  {
    title: "Average Sale",
    number: "$389k",
    color: "secondary",
    percentage: "-10%",
    icon: "icon-arrow-down",
    svg: "sale",
  },
  {
    title: "Gross Profit",
    number: "$3,908",
    color: "success",
    percentage: "+80%",
    icon: "icon-arrow-up",
    svg: "profit",
  },
];

export const ordersAndProfitData = [
  {
    count: "1,80k",
    title: "Orders",
    class: "order",
    chart: ordersChartData,
  },
  {
    count: "6,90k",
    title: "Profit",
    class: "profit",
    chart: profitChartData,
  },
];

export const yourBalanceData:TourBalanceType[] = [
  {
    class: "danger",
    header: "Investment",
    amount: "78.8K",
    badge: "-11.67%",
    arrow: "ArrowDownRight",
  },
  {
    class: "success",
    header: "Cash Back",
    amount: "19.7K",
    badge: "+10.67%",
    arrow: "ArrowUpRight",
  },
];
